module.exports = __webpack_public_path__ + "static/img/80063D_2_3_R_20190321_LC.03e6453.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/80063D_2_3_R_20190321_LC.png
// module id = xQ10
// module chunks = 0